import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Input } from 'hammerjs';
import { titleSplit } from 'src/app/utils/title-split';

@Component({
  selector: 'app-confirmation-modal',
  templateUrl: './confirmation-modal.component.html',
  styleUrls: ['./confirmation-modal.component.scss']
})
export class ConfirmationModalComponent {
  inputdata: any;

  constructor(@Inject(MAT_DIALOG_DATA) public data: any, private ref: MatDialogRef<ConfirmationModalComponent>) {
  }

  ngOnInit(): void {
    this.inputdata = this.data;
  }

  gettitle(title: string | null, part = false): string {
    return titleSplit(title, part);
  }

  closeDialog() {
    this.ref.close();
  }

}
